'use strict';

import _ from 'lodash';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useBaseURL } from './Context';

const {
	chkPrivilege,
} = AuthUtils;

class HAComponent extends React.PureComponent {
	static version = '1.0.0';
	_dom = {};
	_ajax = {};
	state = {};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		//this.cancelablePromise = makeCancelable(new Promise(r => this.setState));
		this._mounted = true;
	}

	componentWillUnmount() {
		this._mounted = false;
		const ajaxs = this._ajax;
		if(ajaxs.isRunning){
			if(ajaxs.isRunning()) ajaxs.cancel();
		}
		else _.forEach(ajaxs, a => a && a.isRunning() ? a.cancel() : null);

// console.log(this, this.cancelablePromise);
// 		if(this.cancelablePromise) this.cancelablePromise.cancel();
	}

	render(){
		return this.props.children;
	}
}

const makeCancelable = (promise) => {
	let hasCanceled_ = false;

	const wrappedPromise = new Promise((resolve, reject) => {
		promise.then(
			val => hasCanceled_ ? reject({isCanceled: true}) : resolve(val),
			error => hasCanceled_ ? reject({isCanceled: true}) : reject(error)
		);
	});

	return {
		promise: wrappedPromise,
		cancel() {
			hasCanceled_ = true;
		},
	};
};

const CheckPermission = ({ permission, children, fallback }) => chkPrivilege(permission) && children || fallback || null;

const NoPermission = props => (
	<div {...{
		className: '-noticeWrapper',
		style: {
			position: 'relative',
			width: 'calc(100% - 8px)',
			backgroundColor: '#FFF',
			border: '1px solid #DDD',
			borderTop: '1px solid #EEE',
			borderBottomLeftRadius: 3,
			borderBottomRightRadius: 3,
			padding: 10,
			marginTop: 10,
			textAlign: 'center',
		},
	}}>
		<div {...{
			className: '-msg msg blue',
			style: {
				padding: 20,
				fontSize: '16px',
			},
		}}>{props.children || <>
			<i className="fa fa-info-circle" /> {props.msg || OptionUtils.getLabel('hp.RouteWrapper', 'verifyOfYourAccount')}
		</>}
		</div>
	</div>
);

const LinkWrapper = props => {
	const baseURL = useBaseURL();
	const to = _.isString(props.to) ? `${baseURL}${props.to}` : { ...props.to, pathname: `${baseURL}${props.to.pathname}` };
	return <Link {...props} to={to} />;
};
const NavLinkWrapper = props => {
	const baseURL = useBaseURL();
	const to = _.isString(props.to) ? `${baseURL}${props.to}` : { ...props.to, pathname: `${baseURL}${props.to.pathname}` };
	return <NavLink {...props} to={to} />;
};

export { HAComponent, CheckPermission, NoPermission, LinkWrapper as Link, NavLinkWrapper as NavLink };
